import useSWR from "swr";
import { Paginated, PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { LoadDurationClassLight } from "./types";

export const useLoadDurationClasses = (query: PaginationQuery, signal: AbortSignal, isAdmin?: boolean) => {
  const api = useApi();
  const prefix = isAdmin ? "/admin" : "";
  const url = buildUrl(`${prefix}/modules/lock_calculator/selects/load_duration_classes`, query);
  return useSWR<Paginated<LoadDurationClassLight>, CustomError, string>(url, (requestUrl) =>
    api.get<Paginated<LoadDurationClassLight>>({ url: requestUrl, signal }),
  );
};
